import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';

import CustomRadios from 'components/base/CustomRadios';
import CustomTitleWithInput from 'components/base/CustomTitleWithInput';
import ErrorFieldMessage, {
  hasErrorFromList,
} from 'components/base/ErrorFieldMessage';
import BasePrompt from 'components/base/prompt/BasePrompt';
import CustomInputWithTitle from 'components/customer/CustomRadioWithTitleAndRelated';
import {
  CustomTitleWithDropDown,
  CustomTitleWithDropDownAndInput,
} from 'components/customer/CustomTitleWithDropDown';
import { EditCustomerHandleError } from 'components/customer/EditCustomerHandleError';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import { PermissionCodes } from 'config/PermissionCodes';
import { ImportResource } from 'models/DownloadImportModel';

import { createAction } from 'utils';
import { tierTypeConfig } from 'config/TierTypeConfig';

const REWARD_TYPE = {
  POINTS: 'POINTS',
  COUPONS: 'COUPONS',
  STAMPS: 'STAMPS',
};

const TRANSACTION_TYPE = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
};

const rewardTypes = [
  { value: REWARD_TYPE.POINTS, label: 'Points & Progress Points' },
  { value: REWARD_TYPE.COUPONS, label: 'Coupons' },
  { value: REWARD_TYPE.STAMPS, label: 'Stamps' },
];

const ERROR_CODE_MESSAGE = {
  segment: {
    name: 'segment',
    message: 'Please provide a static segment',
  },
  customer: {
    name: 'customer',
    message: 'Please provide a customer',
  },
  pointTransaction: {
    name: 'pointTransaction',
    message: 'Please provide a point transaction type',
  },
  transactionPoint: {
    name: 'transactionPoint',
    message: 'Please provide a positive number',
  },
  tpeTransaction: {
    name: 'tpeTransaction',
    message: 'Please provide a progression point transaction type',
  },
  transactionTpe: {
    name: 'transactionTpe',
    message: 'Please provide a positive number',
  },
  transaction: {
    name: 'transaction',
    message: "Must fill in either 'Points' or 'Progression points'",
  },
  quantity: {
    name: 'quantity',
    message: 'Please provide positive number',
  },
  quantityExceed: {
    name: 'quantityExceed',
    message: 'Exceed the Coupon stock left',
  },
  couponSet: {
    name: 'couponSet',
    message: 'Please provide a couponSet',
  },
  store: {
    name: 'store',
    message: 'Please provide a store',
  },
  stampTransaction: {
    name: 'stampTransaction',
    message: 'Please provide a stamp transaction type',
  },
  transactionStamp: {
    name: 'transactionStamp',
    message: 'Please provide a positive number',
  },
  stampCampaign: {
    name: 'stampCampaign',
    message: 'Please provide a stamp campaign',
  },
};

function BulkRewardUpdatePrompt({
  show = false,
  closeAction = () => {},
  user,
  customerList,
  segmentList,
  couponSetList,
  couponStoreList,
  stampCampaignList,
}) {
  const dispatch = useDispatch();

  const [sourceCouponStoreList, setSourceCouponStoreList] = useState([]);

  const [rewardType, setRewardType] = useState(REWARD_TYPE.POINTS);
  const [isMultipleCustomers, setIsultipleCustomers] = useState(tierTypeConfig.segments);
  const [selectedCustomer, setSelectedCustomer] = useState();
  const [selectedSegment, setSelectedSegment] = useState();
  const [remark, setRemark] = useState();

  const [pointTransaction, setPointTransaction] = useState(null);
  const [transactionPoint, setTransactionPoint] = useState(null);
  const [tpeTransaction, setTpeTransaction] = useState(null);
  const [transactionTpe, setTransactionTpe] = useState(null);

  const [couponTransaction, setCouponTransaction] = useState(
    TRANSACTION_TYPE.ADD,
  );
  const [selectedCouponTemplate, setSelectedCouponTemplate] = useState();
  const [isUseStore, setIsUseStore] = useState(false);
  const [selectedStore, setSelectedStore] = useState();
  const [quantity, setQuantity] = useState();

  const [selectedStampCampaign, setSelectedStampCampaign] = useState();
  const [stampTransaction, setStampTransaction] = useState();
  const [transactionStamp, setTransactionStamp] = useState(null);

  const [errors, setErrors] = useState([]);
  const [lastStampCampaignRefreshTime, setLastStampCampaignRefreshTime] = useState()
  // const [resetCouponSetList, setResetCouponSetList] = useState()

  useEffect(() => {
    if (!show) {
      setSourceCouponStoreList([]);
      setRewardType(REWARD_TYPE.POINTS);
      setIsultipleCustomers(tierTypeConfig.segments);
      setSelectedCustomer();
      setSelectedSegment();
      setRemark();
      setPointTransaction(null);
      setTransactionPoint(null);
      setTpeTransaction(null);
      setTransactionTpe(null);
      setCouponTransaction(TRANSACTION_TYPE.ADD);
      setSelectedCouponTemplate();
      setIsUseStore();
      setSelectedStore();
      setQuantity();
      setSelectedStampCampaign();
      setStampTransaction();
      setTransactionStamp(null);
      setErrors([]);
    }
  }, [show]);

  useEffect(() => {
    if (!show) {
      return;
    }
    if (isMultipleCustomers) {
      dispatch(
        createAction('segments/getList')({
          page: 1,
          moreSearch: {
            type: 'STATIC',
          },
          isSelectorLoad: true,
        }),
      );
    } else {
      dispatch(
        createAction('customerList/getPagedCustomers')({
          page: 1,
          isDropdownNode: true,
          isSelectorLoad: true,
        }),
      );
    }
  }, [isMultipleCustomers]);

  useEffect(() => {
    setSourceCouponStoreList(couponStoreList);
  }, [couponStoreList]);

  const getTransactionSource = (isCoupon) => {
    let source = [
      { name: 'Add', pk: TRANSACTION_TYPE.ADD },
      {
        name: 'Remove',
        pk: TRANSACTION_TYPE.REMOVE,
      },
    ];

    if (isCoupon) {
      source = [
        { label: 'Add', value: TRANSACTION_TYPE.ADD },
        {
          label: 'Remove',
          value: TRANSACTION_TYPE.REMOVE,
          innerTips:
            'Remove coupons that are commonly owned by multiple customers',
        },
      ];
    }
    // const permissions = user.userPermissions;
    // if (
    //   permissions.includes(PermissionCodes.addCustomerPoints) ||
    //   permissions.includes(PermissionCodes.adjustAllRewards)
    // ) {
    //   source.push({ name: 'Add', pk: 'ADD_POINTS' });
    // }
    // if (
    //   permissions.includes(PermissionCodes.removeCustomerPoints) ||
    //   permissions.includes(PermissionCodes.adjustAllRewards)
    // ) {
    //   source.push({ name: 'Remove', pk: 'REMOVE_POINTS' });
    // }
    return source;
  };

  const totalCouponNeedAdjust = () => {
    return (
      (isMultipleCustomers ? selectedSegment?.value?.totalActiveCustomers || 0 : 1) *
      (quantity || 0)
    );
  };

  // const loadStampCampaignList = (isCustomerGroup, customer) => {
  //   // const condition = {
  //   //     isStamp: true,
  //   //     expired: 'false',
  //   //     status: 'PUBLISHED',
  //   //     isSelectorLoad: true,
  //   //   }

  //   // if (!isCustomerGroup && customer?.value) {
  //   //   condition.recurringCampaignExpiredByCustomerId = customer.value?.pk

  //   //   if (selectedStampCampaign?.value?.isBirthdayRecurringCampaign && !selectedStampCampaign?.value?.birthdayRecurringActiveMonths?.some((v) => v===parseInt(customer.value?.dateOfBirth.split('-')?.[1]))) {
  //   //     setSelectedStampCampaign()
  //   //   }
  //   // }
  //   // console.log('@@243: ', selectedStampCampaign, customer)
  //   // dispatch(
  //   //   createAction('campaignList/getCampaignList')(condition),
  //   // );

  // }

  const couponPerHeadTips = () => {
    let tips = '';
    if (couponTransaction === TRANSACTION_TYPE.ADD) {
      //   if (quantity) {

      //   }
      if (isMultipleCustomers && selectedSegment) {
        tips += `Total quantity: ${
          selectedSegment?.value?.totalActiveCustomers || 0
        } * ${quantity || 0} = ${totalCouponNeedAdjust()} \n`;
      } else if (!isMultipleCustomers) {
        tips += `Total quantity: 1 * ${
          quantity || 0
        } = ${totalCouponNeedAdjust()} \n`;
      }

      if (selectedCouponTemplate) {
        tips += `Coupon stock left: ${
          selectedCouponTemplate?.value?.stock || 0
        }`;
      }
    }
    return tips;
  };

  const pointBody = () => {
    return (
      <>
        <CustomTitleWithDropDownAndInput
          title="Update points"
          source={getTransactionSource()}
          defaultValue={''}
          needFilter={false}
          unit="Points"
          customClass="edit-custom-transaction-selector customer-detail-prompt-selector"
          setValue={(value) => {
            setPointTransaction(value);
          }}
          setInputValue={(value) => {
            setTransactionPoint(value);
          }}
          // errors={errors}
        />
        <ErrorFieldMessage
          id={ERROR_CODE_MESSAGE.pointTransaction.name}
          error={errors.includes(ERROR_CODE_MESSAGE.pointTransaction.name)}
          message={ERROR_CODE_MESSAGE.pointTransaction.message}
        />
        <ErrorFieldMessage
          id={ERROR_CODE_MESSAGE.transactionPoint.name}
          error={errors.includes(ERROR_CODE_MESSAGE.transactionPoint.name)}
          message={ERROR_CODE_MESSAGE.transactionPoint.message}
        />

        <CustomTitleWithDropDownAndInput
          title="Update progression points"
          source={getTransactionSource()}
          defaultValue={''}
          needFilter={false}
          unit="Progression Points"
          customClass="edit-custom-transaction-selector customer-detail-prompt-selector"
          setValue={(value) => {
            setTpeTransaction(value);
          }}
          setInputValue={(value) => {
            setTransactionTpe(value);
          }}
          // errors={errors}
        />
        <ErrorFieldMessage
          id={ERROR_CODE_MESSAGE.tpeTransaction.name}
          error={errors.includes(ERROR_CODE_MESSAGE.tpeTransaction.name)}
          message={ERROR_CODE_MESSAGE.tpeTransaction.message}
        />
        <ErrorFieldMessage
          id={ERROR_CODE_MESSAGE.transactionTpe.name}
          error={errors.includes(ERROR_CODE_MESSAGE.transactionTpe.name)}
          message={ERROR_CODE_MESSAGE.transactionTpe.message}
        />

        <ErrorFieldMessage
          id={ERROR_CODE_MESSAGE.transaction.name}
          error={errors.includes(ERROR_CODE_MESSAGE.transaction.name)}
          message={ERROR_CODE_MESSAGE.transaction.message}
        />
      </>
    );
  };

  const couponBody = () => {
    return (
      <>
        <CustomTitleLabel title="Purpose" />
        <CustomRadios
          className="d-flex"
          onChange={(value) => {
            setCouponTransaction(value);
            // setResetCouponSetList(true)
          }}
          default={couponTransaction}
          options={getTransactionSource(true)}
        />

        <CustomTitleWithDropDown
          // customClass={'filter-title'}
          title={'Coupon set'}
          toolTips={
            couponTransaction === TRANSACTION_TYPE.REMOVE
              ? 'Showing all coupon set here. If the selected customers does not owned the coupon, will show error in system task.'
              : ''
          }
          source={couponSetList}
          placeholder={'Search by coupon set ID and name'}
          labelContainPk
          defaultValue={selectedCouponTemplate}
          setValue={(v) => {
            setSelectedCouponTemplate(v);
            if (isUseStore && v?.id) {
              dispatch(
                createAction('storeModel/getAllCouponStores')({
                  couponTemplateId: v?.id,
                  needStock: true,
                }),
              );
            }
          }}
          loadMoreAction={'couponList/getList'}
          // customFilter={customFilter}
          filterAction={'couponList/getList'}
          defaultFilter={{
            searchField: 'searchNameOrId'
          }}
          customItem={(item) =>
            `${!item?.stock && couponTransaction === TRANSACTION_TYPE.ADD  ? `[Out of stock] - ` : ''}[ID: ${item?.pk}] ${
              item?.name
            }`
          }
          customItemDisabled={(item) => !item?.stock && couponTransaction === TRANSACTION_TYPE.ADD}
          // isReset={resetCouponSetList}
          // resetChange={() => setResetCouponSetList()}
        />
        <ErrorFieldMessage
          id={ERROR_CODE_MESSAGE.couponSet.name}
          error={errors.includes(ERROR_CODE_MESSAGE.couponSet.name)}
          message={ERROR_CODE_MESSAGE.couponSet.message}
        />

          {couponTransaction === TRANSACTION_TYPE.ADD ? (
            <>
              <CustomTitleLabel title="Store selection" />
              <CustomRadios
                className="d-flex"
                onChange={(value) => {
                  setIsUseStore(value);

                  if (value && selectedCouponTemplate) {
                    dispatch(
                      createAction('storeModel/getAllCouponStores')({
                        couponTemplateId: selectedCouponTemplate.value?.pk,
                        needStock: true,
                      }),
                    );
                  }
                }}
                default={isUseStore}
                options={[
                  { label: 'Customer select', value: false },
                  {
                    label: 'Select store now',
                    value: true,
                  },
                ]}
              />
          </>
          ) : null}



        {isUseStore && couponTransaction === TRANSACTION_TYPE.ADD ? (
          <>
            <CustomTitleWithDropDown
              // customClass={'filter-title'}
              title={'Store'}
              source={sourceCouponStoreList}
              placeholder={'Search by store ID and name'}
              labelContainPk
              defaultValue={selectedStore}
              setValue={(v) => {
                setSelectedStore(v);
              }}
              // loadMoreAction={'couponList/getList'}
              // customFilter={customFilter}
              filterAction={(inputValue, option) => {
                const inputIgnoreCase = inputValue?.toLowerCase();

                setSourceCouponStoreList(
                  couponStoreList.filter((item) => {
                    const optionIgnoreCase = item?.name?.toLowerCase();
                    return (
                      optionIgnoreCase?.includes(inputIgnoreCase) ||
                      item?.id == inputValue
                    );
                  }),
                );
              }}
              defaultFilter={{
                searchField: 'searchIdOrName',
                needStock: true,
              }}
              customItem={(item) =>
                `${!item?.stock ? `[Out of stock] - ` : ''}[${item?.id}] ${
                  item?.name
                }${item?.visibleInFrontEnd ? '' : ' (closed)'}`
              }
              showItemDescription
              customItemDescription={(item) => `${item?.address}`}
              customItemDisabled={(item) => !item?.stock}
            />
            <ErrorFieldMessage
              id={ERROR_CODE_MESSAGE.store.name}
              error={errors.includes(ERROR_CODE_MESSAGE.store.name)}
              message={ERROR_CODE_MESSAGE.store.message}
            />
          </>
        ) : null}

        <CustomTitleWithInput
          title={'Coupon quantity per head'}
          type="number"
          defaultValue={quantity}
          setValue={setQuantity}
          shortDescription={
            // couponTransaction === TRANSACTION_TYPE.ADD
            //   ? `Total quantity: ${
            //       isMultipleCustomers
            //         ? selectedSegment?.value?.totalCustomers || 0
            //         : 1
            //     } * ${
            //       quantity || 0
            //     } = ${totalCouponNeedAdjust()} \nCoupon stock left: ${
            //       selectedCouponTemplate?.value?.stock || 0
            //     }`
            //   : ''
            couponPerHeadTips()
          }
          error={{
            id: ERROR_CODE_MESSAGE.quantity,
            error:
              errors.includes(ERROR_CODE_MESSAGE.quantity.name) ||
              errors.includes(ERROR_CODE_MESSAGE.quantityExceed.name),
            message: errors.map((errorCode) => {
              if (
                [
                  ERROR_CODE_MESSAGE.quantity.name,
                  ERROR_CODE_MESSAGE.quantityExceed.name,
                ].includes(errorCode)
              ) {
                return ERROR_CODE_MESSAGE[errorCode].message;
              }
              return undefined;
            }),
          }}
          extra={{
            min: 1,
          }}
        />
      </>
    );
  };

  const stampBody = () => {
    return (
      <>
        <CustomTitleWithDropDown
          // customClass={'filter-title'}
          title={'Stamp campaign'}
          toolTips={
            'Showing all stamp campaign here. If the selected customers are not eligible to the stamp campaign, will show error in system task.'
          }
          source={stampCampaignList}
          placeholder={'Search by stamp campaign ID and name'}
          labelContainPk
          defaultValue={selectedStampCampaign}
          setValue={(v) => {
            setSelectedStampCampaign(v);
          }}
          loadMoreAction={'campaignList/getCampaignList'}
          // customFilter={customFilter}
          filterAction={'campaignList/getCampaignList'}
          defaultFilter={{
            isStamp: true,
            expired: 'false',
            status: 'PUBLISHED',
            isSelectorLoad: true,
            searchField: 'searchNameOrId',
            reverse: true,
            ...(!isMultipleCustomers && selectedCustomer?.value ? {
              recurringCampaignExpiredByCustomerId: selectedCustomer.value?.pk
            } : {})
          }}
          isReset={lastStampCampaignRefreshTime}
          resetChange={() => {
            if (!isMultipleCustomers
              && selectedCustomer?.value
              && selectedStampCampaign?.value?.isBirthdayRecurringCampaign
              && !selectedStampCampaign?.value?.birthdayRecurringActiveMonths?.some((v) => v===parseInt(selectedStampCampaign?.value?.dateOfBirth?.split('-')?.[1]))
            ) {
              setSelectedStampCampaign()
            }
            setLastStampCampaignRefreshTime()
          }}
        />
        <ErrorFieldMessage
          id={ERROR_CODE_MESSAGE.stampCampaign.name}
          error={errors.includes(ERROR_CODE_MESSAGE.stampCampaign.name)}
          message={ERROR_CODE_MESSAGE.stampCampaign.message}
        />

        <CustomTitleWithDropDownAndInput
          title="Stamps"
          source={getTransactionSource()}
          defaultValue={''}
          needFilter={false}
          unit="Stamps"
          customClass="edit-custom-transaction-selector customer-detail-prompt-selector"
          setValue={(value) => {
            setStampTransaction(value);
          }}
          setInputValue={(value) => {
            setTransactionStamp(value);
          }}
        />
        <ErrorFieldMessage
          id={ERROR_CODE_MESSAGE.stampTransaction.name}
          error={errors.includes(ERROR_CODE_MESSAGE.stampTransaction.name)}
          message={ERROR_CODE_MESSAGE.stampTransaction.message}
        />
        <ErrorFieldMessage
          id={ERROR_CODE_MESSAGE.transactionStamp.name}
          error={errors.includes(ERROR_CODE_MESSAGE.transactionStamp.name)}
          message={ERROR_CODE_MESSAGE.transactionStamp.message}
        />
      </>
    );
  };

  const getOtherBody = () => {
    return (
      <div className="d-flex flex-column">
        <CustomTitleLabel title={'Rewards type'} />
        <CustomRadios
          className="d-flex"
          onChange={(value) => {
            setRewardType(value);
            if (value === REWARD_TYPE.STAMPS) {
              // loadStampCampaignList(isMultipleCustomers, selectedCustomer)
              setLastStampCampaignRefreshTime(true)
            }
          }}
          default={rewardType}
          options={rewardTypes}
        />
        <CustomTitleLabel title={'Customer'} />
        <CustomRadios
          className="d-flex"
          onChange={(value) => {
            setIsultipleCustomers(value);
            // loadStampCampaignList(value, selectedCustomer)
            setLastStampCampaignRefreshTime(true)
          }}
          default={isMultipleCustomers}
          options={[
            {
              label: 'Target static segment',
              value: true,
            },
            {
              label: 'Individual customer',
              value: false,
            },
          ].filter(option => {
            if (!tierTypeConfig.segments && option.label === 'Target static segment') {
              return false;
            }
            return true;
          })}
        />
        {isMultipleCustomers ? (
          <CustomTitleWithDropDown
            // customClass={'filter-title'}
            title={'Target static segment'}
            source={segmentList}
            placeholder={'Search for...'}
            labelContainPk
            defaultValue={selectedSegment}
            setValue={(v) => {
              setSelectedSegment(v);
            }}
            loadMoreAction={'segments/getList'}
            // customFilter={customFilter}
            filterAction={'segments/getList'}
            defaultFilter={{
              moreSearch: {
                type: 'STATIC',
              },
            }}
          />
        ) : (
          <CustomTitleWithDropDown
            // customClass={'filter-title'}
            title={'Customers'}
            source={customerList}
            placeholder={'Search for...'}
            labelContainPk
            defaultValue={selectedCustomer}
            setValue={(v) => {
              setSelectedCustomer(v);
              if (rewardType === REWARD_TYPE.STAMPS) {
                // loadStampCampaignList(isMultipleCustomers, v)
                setLastStampCampaignRefreshTime(true)
              }
            }}
            loadMoreAction={'customerList/getPagedCustomers'}
            // customFilter={customFilter}
            filterAction={'customerList/getPagedCustomers'}
            defaultFilter={{
              isDropdownNode: true,
              isSelectorLoad: true
            }}
            // multiple={true}
            // toolTips={true}
            // notShowLabel={true}
            // disableAutoFocus={true}
            customItem={(item) => `[${item.membershipId}] ${item.name}`}
          />
        )}
        <ErrorFieldMessage
          id={ERROR_CODE_MESSAGE.segment.name}
          error={errors.includes(ERROR_CODE_MESSAGE.segment.name)}
          message={ERROR_CODE_MESSAGE.segment.message}
        />
        <ErrorFieldMessage
          id={ERROR_CODE_MESSAGE.customer.name}
          error={errors.includes(ERROR_CODE_MESSAGE.customer.name)}
          message={ERROR_CODE_MESSAGE.customer.message}
        />
        {rewardType === REWARD_TYPE.POINTS ? pointBody() : null}
        {rewardType === REWARD_TYPE.COUPONS ? couponBody() : null}
        {rewardType === REWARD_TYPE.STAMPS ? stampBody() : null}

        <CustomTitleLabel title="Remarks(Optional)" />
        <textarea
          onChange={({ target }) => {
            const value = target.value;
            setRemark(value);
          }}
          className="custom-textarea-input-box customer-detail-textarea-input"
          value={remark}
        />
      </div>
    );
  };

  const checkValid = () => {
    const errorList = [];
    if (isMultipleCustomers && !selectedSegment?.value) {
      errorList.push('segment');
    } else if (!isMultipleCustomers && !selectedCustomer?.value) {
      errorList.push('customer');
    }
    switch (rewardType) {
      case REWARD_TYPE.POINTS:
        if (!pointTransaction?.value && !transactionPoint && !tpeTransaction?.value && !transactionTpe) {
          errorList.push('transaction');
          // errorList.push('update points');
          // errorList.push('update progression points');
        } else {
          if (!pointTransaction?.value && transactionPoint) {
            errorList.push('pointTransaction');
            // errorList.push('update points')
          }
          if (!transactionPoint && pointTransaction?.value) {
            errorList.push('transactionPoint');
            // errorList.push('update points')
          }

          if (!tpeTransaction?.value && transactionTpe) {
            errorList.push('tpeTransaction');
            // errorList.push('update progression points')
          }
          if (!transactionTpe && tpeTransaction?.value) {
            errorList.push('transactionTpe');
            // errorList.push('update progression points')
          }
        }
        // if (!pointTransaction?.value) {
        //   errorList.push('pointTransaction');
        // }
        // if (!transactionPoint) {
        //   errorList.push('transactionPoint');
        // }

        // if (!tpeTransaction?.value) {
        //   errorList.push('tpeTransaction');
        // }
        // if (!transactionTpe) {
        //   errorList.push('transactionTpe');
        // }
        break;
      case REWARD_TYPE.COUPONS:
        if (!quantity) {
          errorList.push('quantity');
        } else if (
          couponTransaction === TRANSACTION_TYPE.ADD && totalCouponNeedAdjust() > selectedCouponTemplate?.value?.stock
        ) {
          errorList.push('quantityExceed');
        }
        if (!selectedCouponTemplate?.value) {
          errorList.push('couponSet');
        }
        if (
          isUseStore &&
          couponTransaction === TRANSACTION_TYPE.ADD &&
          !selectedStore?.value
        ) {
          errorList.push('store');
        }
        break;
      case REWARD_TYPE.STAMPS:
        if (!stampTransaction?.value) {
          errorList.push('stampTransaction');
        }
        if (!transactionStamp) {
          errorList.push('transactionStamp');
        }
        if (!selectedStampCampaign?.value) {
          errorList.push('stampCampaign');
        }
        break;
    }

    return errorList;
  };

  return (
    <BasePrompt
      customClass={'bulk-reward-update-modal'}
      show={show}
      title={'Create Bulk Rewards Updates'}
      description={''}
      closeAction={closeAction}
      otherBody={getOtherBody}
      leftButton={{
        text: 'Cancel',
        action: () => {
          closeAction();
        },
      }}
      rightButton={{
        text: 'Confirm',
        action: () => {
          const errorList = checkValid();
          if (errorList.length > 0) {
            setErrors(errorList);
            return;
          }

          const related = {
            remark: remark,
          };
          if (isMultipleCustomers) {
            related.segment = selectedSegment.value.pk;
          } else {
            related.customerId = selectedCustomer.value.pk;
          }
          switch (rewardType) {
            case REWARD_TYPE.POINTS:
              related.rewardType = rewardType;
              const changeTypes = []
              if (pointTransaction?.value) {
                changeTypes.push({
                  type: `${pointTransaction?.value}_POINTS`,
                  quantity: transactionPoint,
                })
              }
              if (tpeTransaction?.value) {
                changeTypes.push({
                  type: `${tpeTransaction?.value}_TPES`,
                  quantity: transactionTpe,
                })
              }
              related.changeTypes = JSON.stringify(changeTypes);
              break;
            case REWARD_TYPE.COUPONS:
              related.rewardType = `${couponTransaction}_${rewardType}`;
              related.quantity = quantity;

              related.templateId = selectedCouponTemplate.value.pk;
              related.storeId = selectedStore?.value?.id;
              break;
            case REWARD_TYPE.STAMPS:
              related.rewardType = `${stampTransaction.value}_${rewardType}`;
              related.quantity = transactionStamp;
              related.stampCampaignId = selectedStampCampaign.value.pk;
              break;
            default:
              break;
          }

          dispatch(
            createAction('downloadAndImport/importFile')({
              from: ImportResource.createBulkReward,
              file: { import: null },
              //   file: null,
              related: related,
              //   successAction,
            }),
          );

          closeAction();
        },
      }}
    />
  );
}

const mapPropsToState = (state) => ({
  user: state.users,
  customerList: state.customerList.customerList || [],
  segmentList: state.segments.allList || [],
  couponSetList: state.couponList.allList || [],
  couponStoreList: state.storeModel.couponStores?.stores || [],
  stampCampaignList: state.campaignList.allList || [],
});

export default connect(mapPropsToState)(BulkRewardUpdatePrompt);
